export const buildSearchUrl = (hint: string | null): string | null => {
  if (!hint) return null;
  const trimmed = hint.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://www.google.com/search?q=${encodeURIComponent(trimmed)}`;
};

export const sourceLabel = (hint: string | null): string | null => {
  if (!hint || !/^https?:\/\//i.test(hint)) return null;
  try {
    const host = new URL(hint).hostname.replace(/^www\./, "");
    const map: Record<string, string> = {
      "internshala.com": "Internshala",
      "wellfound.com": "Wellfound",
      "contra.com": "Contra",
      "devfolio.co": "Devfolio",
      "unstop.com": "Unstop",
      "mlh.io": "MLH",
      "github.com": "GitHub",
      "linkedin.com": "LinkedIn",
    };
    return map[host] || host;
  } catch {
    return null;
  }
};
